import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface CheckCircleFillIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const CheckCircleFillIcon = ({ className, ...props }: CheckCircleFillIconProps) => (
  <svg
    className={cn("text-[#1E8E3E]", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM17.5303 7.96973C17.2374 7.67717 16.7625 7.677 16.4697 7.96973L10 14.4395L7.53027 11.9697C7.23738 11.6768 6.76262 11.6768 6.46973 11.9697C6.17683 12.2626 6.17683 12.7374 6.46973 13.0303L9.46973 16.0303C9.76265 16.3228 10.2375 16.3231 10.5303 16.0303L17.5303 9.03027C17.823 8.73748 17.8228 8.26263 17.5303 7.96973Z"
      fill="currentColor"
    />
  </svg>
);

export default CheckCircleFillIcon;
